export default __webpack_public_path__ + "static/media/medal.4ff760bc.svg";